import { jsx as _jsx } from "react/jsx-runtime";
import { Alert as HeroAlert } from '@heroui/react';
export const Alert = (props) => {
    return _jsx(HeroAlert, { ...props });
};
export default Alert;
//# sourceMappingURL=Alert.js.map